// extracted by mini-css-extract-plugin
export default {"errorContainer":"ErrorPage_errorContainer__vcn0-","errorImg":"ErrorPage_errorImg__c1rKD","linkToHome":"ErrorPage_linkToHome__h9OwG"};